import createIcon from '../../createIcon';

/**
 * @component @name CopyAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAySDkuNUM4LjQgMiA3LjUgMi45IDcuNSA0VjE2QzcuNSAxNy4xIDguNCAxOCA5LjUgMThIMTguNUMxOS42IDE4IDIwLjUgMTcuMSAyMC41IDE2VjRDMjAuNSAyLjkgMTkuNiAyIDE4LjUgMlpNMTguNSAxNkg5LjVWNEgxOC41VjE2Wk0zLjUgMTVWMTNINS41VjE1SDMuNVpNMy41IDkuNUg1LjVWMTEuNUgzLjVWOS41Wk0xMC41IDIwSDEyLjVWMjJIMTAuNVYyMFpNMy41IDE4LjVWMTYuNUg1LjVWMTguNUgzLjVaTTUuNSAyMkM0LjQgMjIgMy41IDIxLjEgMy41IDIwSDUuNVYyMlpNOSAyMkg3VjIwSDlWMjJaTTE0IDIyVjIwSDE2QzE2IDIxLjEgMTUuMSAyMiAxNCAyMlpNNS41IDZWOEgzLjVDMy41IDYuOSA0LjQgNiA1LjUgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CopyAll = createIcon('CopyAll', [
  [
    'path',
    {
      d: 'M18.5 2H9.5C8.4 2 7.5 2.9 7.5 4V16C7.5 17.1 8.4 18 9.5 18H18.5C19.6 18 20.5 17.1 20.5 16V4C20.5 2.9 19.6 2 18.5 2ZM18.5 16H9.5V4H18.5V16ZM3.5 15V13H5.5V15H3.5ZM3.5 9.5H5.5V11.5H3.5V9.5ZM10.5 20H12.5V22H10.5V20ZM3.5 18.5V16.5H5.5V18.5H3.5ZM5.5 22C4.4 22 3.5 21.1 3.5 20H5.5V22ZM9 22H7V20H9V22ZM14 22V20H16C16 21.1 15.1 22 14 22ZM5.5 6V8H3.5C3.5 6.9 4.4 6 5.5 6Z',
      key: '1n1kjh',
    },
  ],
]);

export default CopyAll;
